<template>
    <div>
      <HeaderBar/>
  
      <div class="d-flex justify-content-center headTitle mb-1 mt-4">Vacunas</div>
      <div class="d-flex justify-content-center mt-1 headTitle mb-2">{{animalData.number}}-{{animalData.name}}</div>
  
  
      <!-- table -->
      <vue-good-table :columns="columns" :rows="rows"
        :search-options="{
          enabled: false,
        
        }" 
        
        :pagination-options="{
          enabled: true,
          perPage: pageLength
        }"
        
      >
        <template slot="table-row" slot-scope="props">
  
          <!-- Column: Common -->
          <span>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
  
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap ">
                Mostrando 1 de
              </span>
              <b-form-select v-model="pageLength" :options="['25', '50', '100']" class="mx-1"
                @input="(value) => props.perPageChanged({ currentPerPage: value })" />
              <span class="text-nowrap"> of {{ props.total }} registros </span>
            </div>
          </div>
        </template>
      </vue-good-table>
    <ControlMenu />
    </div>
  </template>
  
  <script>
  import ControlMenu from '@/components/ControlMenu.vue'
  import HeaderBar from '@/components/HeaderBar.vue'
  import vSelect from 'vue-select'
  import "vue-select/dist/vue-select.css";
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import {
    BAvatar, BBadge, BPagination, BFormGroup, BFormSelect, BFormCheckbox, BDropdown, BDropdownItem, BRow, BCol, BLink, BCardBody, BCard, BButton, BForm, BFormInput, BInputGroup, BImg, BCardTitle, BCardText,
  } from 'bootstrap-vue'
  import { VueGoodTable } from 'vue-good-table'
  import AddButton from '@/components/AddButton.vue'

  export default {
    components: {
      BRow,
      BImg,
      BCol,
      BLink,
      BButton,
      BForm,
      BCardText,
      BCardTitle,
      BFormCheckbox,
      BInputGroup,
      BCardBody,
      BCard,
      VueGoodTable,
      vSelect,
      ValidationProvider,
      ValidationObserver,
      BFormCheckbox,
      BAvatar,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      ControlMenu,
      HeaderBar,
      AddButton
  
    },
    data() {
      return {
        fincaName:localStorage.getItem('currentFarmName'),
        currAmimal:0,
        pageLength: 25,
        dir: false,
        status1: null,
        status2: null,
        modalShow: false,
        modalCase: 0,
        editShow:false,
        modalTrashShow:false,
        columns: [
        {
            label: 'Fecha',
            field: 'date',
          },  
          {
            label: 'NOMBRE',
            field: 'name',
          }
  
        ],
        rows: [],
        InfrastructuresView:[],
        animalData:{
            number:'',
            name:''
        },
        searchTerm: '',
      }
    },
    computed: {
      statusVariant() {
        const statusColor = {
          /* eslint-disable key-spacing */
          Current: 'light-primary',
          Professional: 'light-success',
          Rejected: 'light-danger',
          Resigned: 'light-warning',
          Applied: 'light-info',
          /* eslint-enable key-spacing */
        }
  
        return status => statusColor[status]
      },
    },
    methods:{
        async fetchAnimalData(config){
            let id= parseInt(this.$route.params.id);
            fetch(this.$apiUrl+"view/animals/"+id, config)
            .then(response => response.json())
            .then(result => {
                this.animalData = result.animals;
            })
        },
        async fetchVaccines(config){
            let id= parseInt(this.$route.params.id);
            fetch(this.$apiUrl+"list/VaccinationsByAnimals?animal_id="+id, config)
            .then(response => response.json())
            .then(result => {
                result.VaccinationsByAnimals.map(item => {
                    if(item.animal_id==id){
                        console.log(item)
                        this.rows.push({date:item.date, name:item.vaccine})
                    }
                })

            })
        },
    },
    created() {
      const token = localStorage.getItem("accessToken");
      const config = {headers: {"X-Authorization": `Bearer ${token}`}};
      this.fetchAnimalData(config);
      this.fetchVaccines(config);
    },
  }
  </script>
  <style>
  body {
    background-color: white !important;
  }
  
  table{
    width: 100% !important;
  }
  .subTitle {
    font-weight: 600;
    font-size: 23px;
  
  }
  
  .linkTitle {
  
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    letter-spacing: 0.4px;
    color: #5E8F23;
  
  }
  
  .headTitle {
    font-weight: 600;
    font-size: 24px;
    color: #5E8F23;
  }
  
  thead{
    background-color: #5E8F23;
    text-align:center;
    color:#ffffff;
  }
  thead> tr{
    padding:5px;
  }
  .editAnimal {
    font-weight: 500;
    font-size: 18px;
  }
  
  
  .editModal {
    font-weight: 500;
    font-size: 18px;
  }
  
  span.text-center{
    display:flex;
    justify-content: center;
    text-align: center;
  }
  </style>